import { isCurrentLocaleDefault } from '@web/assets/i18n/helper.js'

function formatRate(override, from, to, suffix) {
  const langFrom = isCurrentLocaleDefault() ? 'od' : 'from'
  const langTo = isCurrentLocaleDefault() ? 'do' : 'to'

  let rate = ''
  if (override) {
    rate = override
  } else if (from && to) {
    rate = `${ from } – ${ to } ${ suffix }`
  } else if (from) {
    rate = `${ langFrom } ${ from } ${ suffix }`
  } else if (to) {
    rate = `${ langTo } ${ to } ${ suffix }`
  }

  return rate
}

export default formatRate
